/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'hide-password': {
    width: 32,
    height: 20,
    viewBox: '0 0 32 20',
    data: '<path pid="0" d="M16 19.625c-5.17 0-9.97-2.75-14.523-8.125-.739-.875-.739-2.25 0-3.125C6.03 3 10.83.25 16 .25S25.97 3 30.523 8.375c.739.875.739 2.25 0 3.125C25.97 16.875 21.17 19.625 16 19.625zM2.954 9.75c-.123.125-.123.375 0 .625C7.015 15.25 11.446 17.75 16 17.75c4.554 0 8.985-2.5 13.046-7.375.123-.125.123-.375 0-.625C24.985 4.875 20.554 2.375 16 2.375 11.446 2.25 7.015 4.75 2.954 9.75zm13.046 6c-3.077 0-5.662-2.625-5.662-5.75S12.923 4.25 16 4.25s5.662 2.625 5.662 5.75-2.585 5.75-5.662 5.75zm0-9.625c-2.092 0-3.815 1.75-3.815 3.875s1.723 3.875 3.815 3.875c2.092 0 3.815-1.75 3.815-3.875S18.092 6.125 16 6.125z"/>'
  }
})
